import React from "react";
import dayjs from "dayjs";
import { DismissedIcon, AssignedIcon, BulkActionIcon, UnassignedIcon } from "@assets/icons";
import styles from "@/pages/query/styles.module.scss";

const TimelineScheduledEventIconWithDate = (
  _owner: string,
  eventType: string,
  eventTime: string
): React.ReactElement => {
  const isoDatetime = dayjs(eventTime);
  const formattedDate = isoDatetime.format("MMM DD, YYYY");
  const formattedTime = isoDatetime.format("hh:mm A");

  const scheduledEventsTimelineIconMap: Record<string, React.ReactElement> = {
    rejected: <UnassignedIcon />,
    approved: <AssignedIcon />,
    dismissed: <DismissedIcon />,
  };

  return (
    <>
      {scheduledEventsTimelineIconMap[eventType] || <BulkActionIcon />}
      <div className={styles.timeline_event_icon}>{formattedDate}</div>
      <div className={styles.timeline_event_icon_time}>{formattedTime}</div>
    </>
  );
};

export default TimelineScheduledEventIconWithDate;
